<template>
  <div class="container">
    <DeviceHistoryDialog
      :visible.sync="deviceHistoryDialogVisible"
      :device-id="deviceId"
    />
    <el-form :model="form" inline ref="refForm" :rules="rules">
      <el-form-item class="small_label" :label="$t('common.deviceCategory') + ':'" prop="deviceCategory">
        <el-select
          v-model="form.deviceCategory"
          filterable
          multiple
          collapse-tags
          size="small"
          style="width: 200px;">
          <el-option
            v-for="item in defaultCategoryTypes"
            :key="item.value"
            :label="item.explain"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.address') + ':'" prop="address">
        <el-input
          v-model.trim="form.address"
          name="address"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="255"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.deviceName') + ':'" prop="deviceName">
        <el-input
          v-model.trim="form.deviceName"
          name="deviceName"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.deviceModel') + ':'" prop="deviceModel">
        <el-input
          v-model.trim="form.deviceModel"
          name="deviceModel"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.deviceNumber') + ':'" prop="deviceNumber">
        <el-input
          v-model.trim="form.deviceNumber"
          name="deviceNumber"
          type="text"
          autocomplete="on"
          clearable
          size="small"
          style="width: 200px;"
          maxlength="64"
        />
      </el-form-item>
      <el-form-item class="small_label" :label="$t('common.status') + ':'" prop="status">
        <el-select
          v-model="form.status"
          clearable
          filterable
          size="small"
          style="width: 150px;">
          <el-option
            v-for="item in defaultDeviceStatus"
            :key="item.value"
            :label="item.explain"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" @click="reset">{{$t('common.reset')}}</el-button>
        <el-button :loading="loading" type="primary" size="small" @click="queryDevice">
          {{$t('common.query')}}
        </el-button>
      </el-form-item>
    </el-form>
    <div class="control-container">
      <router-link to="/asset-management/subDevice" style="margin-right: 10px">
        <el-button type="warning" size="small">
          {{$t('device.componentManagement')}}
        </el-button>
      </router-link>
      <router-link to="/device/create" style="margin-right: 10px">
        <el-button type="warning" size="small">
          {{$t('device.addNewDevice')}}
        </el-button>
      </router-link>
      <el-button :loading="exportLoading" @click="exportDeviceList" type="warning" size="small">
        {{$t('common.exportDeviceList')}}
      </el-button>
    </div>
    <div class="target-container">
      <el-table
        ref="table"
        height="100%"
        border
        :data="displayData"
        :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
        :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
        header-cell-class-name="headerCellName">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-table
              max-height="400"
              border
              :data="scope.row.subDevice"
              :cell-style="{textAlign: 'center', padding: '8px 0', fontSize: '12px'}"
              :header-cell-style="{textAlign: 'center', padding: '5px 0', fontSize: '12px', color: '#303133', fontFamily: 'SimHei'}"
              header-cell-class-name="headerCellName">
              <el-table-column prop="addr" :label="$t('common.address')"/>
              <el-table-column prop="deviceName" :label="$t('common.componentName')"/>
              <el-table-column prop="deviceModel" :label="$t('common.componentModel')"/>
              <el-table-column prop="deviceNo" :label="$t('common.componentNumber')"/>
              <el-table-column prop="productionDate" :label="$t('common.productionDate')">
                <template slot-scope="scope">
                  {{scope.row.productionDate | toDateFormatFilter}}
                </template>
              </el-table-column>
              <el-table-column prop="softwareVersion" :label="$t('common.softwareVersion')"/>
              <el-table-column prop="deviceSerialNo" :label="$t('common.componentSerialNo')"/>
              <el-table-column prop="status" :label="$t('common.status')">
                <template slot-scope="scope">
                  {{subDeviceStatusVal(scope.row)}}
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.deviceCategory')">
          <template slot-scope="scope">
            {{deviceCategoryVal(scope.row.flag)}}
          </template>
        </el-table-column>
        <el-table-column prop="addr" :label="$t('common.address')"/>
        <el-table-column prop="deviceName" :label="$t('common.deviceName')"/>
        <el-table-column prop="deviceModel" :label="$t('common.deviceModel')"/>
        <el-table-column prop="deviceNo" :label="$t('common.deviceNumber')"/>
        <el-table-column prop="productionDate" :label="$t('common.productionDate')">
          <template slot-scope="scope">
            {{formatDate(scope.row.productionDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="installationDate" :label="$t('common.installDate')">
          <template slot-scope="scope">
            {{formatDate(scope.row.installationDate)}}
          </template>
        </el-table-column>
        <el-table-column prop="testDaily" :label="$t('common.supportProducts') + ':' + $t('common.dailyEnergy') + '/K'">
          <template slot-scope="scope">
            {{supportsVal(scope.row.supports)}}
          </template>
        </el-table-column>
        <el-table-column prop="softwareVersion"  :label="$t('common.softwareVersion')"/>
        <el-table-column :label="$t('common.status')">
          <template slot-scope="scope">
            {{deviceStatusVal(scope.row)}}
          </template>
        </el-table-column>
        <el-table-column prop="comment" :label="$t('common.comment')" show-overflow-tooltip/>
        <el-table-column :label="$t('common.label')" width="80">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="link"
              @click="printDeviceLabel(scope.row)">
              {{$t('common.print')}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.deviceHistory')" width="80">
          <template slot-scope="scope">
            <el-button
              type="text"
              class="link"
              @click="checkDeviceHistory(scope.row.id)">
              {{$t('common.check')}}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operate')" width="120">
          <template slot-scope="scope">
            <router-link :to="'/device/edit/' + scope.row.id">
              <el-button type="text" class="link" >
                {{$t('common.revise')}}
              </el-button>
            </router-link>
            <el-button
              type="text"
              class="link"
              @click="deleteDevice(scope.row.id)">
              {{$t('common.delete')}}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <pagination
      :total="totalCount"
      :pageSize="perpage"
      :current-page.sync="page"
      @current-change="onChangePage"
    />
  </div>
</template>

<script>
import {
  deviceDelete,
  devicesList,
} from '@/api/device';
import {
  Pagination,
} from '@/components';
import {
  defaultCategoryTypes,
  defaultDeviceStatus,
  defaultSubDeviceStatus,
} from '@/utils/defines';
import moment from "moment";
import {isValueEmpty, remove_ie_header_and_footer} from "@/utils";
import {initDeviceLabel} from '@/utils/deviceLabel';
import DeviceHistoryDialog from '../components/DeviceHistoryDialog';
import exportDeviceXlsx from "@/utils/exportDevice";

const defaultForm = {
  deviceCategory: [1, 2, 3],
  address: undefined,
  deviceName: undefined,
  deviceModel: undefined,
  deviceNumber: undefined,
  status: undefined,
};

export default {
  name: "DeviceManagement",
  components: {
    Pagination,
    DeviceHistoryDialog,
  },
  data() {
    return {
      form: Object.assign({}, defaultForm),
      searchParams: Object.assign({}, defaultForm),
      rules: {
        deviceCategory: [{required: true, trigger: 'change', message: this.$t('validate.deviceCategoryCanNotBeEmpty') }],
      },
      page: 1,
      perpage: 20,
      totalCount: 0,
      listData: [],
      loading: false,
      defaultCategoryTypes,
      defaultDeviceStatus,
      deviceHistoryDialogVisible: false,
      deviceId: undefined,
      exportLoading: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.devicesList();
    })
  },
  computed: {
    displayData() {
      return this.listData;
    },
  },
  methods: {
    onChangePage() {
      this.devicesList();
    },
    async devicesList() {
      const {
        deviceCategory,
        address,
        deviceName,
        deviceModel,
        deviceNumber,
        status,
      } = this.searchParams;
      const {
        page,
        perpage,
      } = this;
      this.loading = true;
      let flag = [];
      if (deviceCategory && deviceCategory.length === 1) {
        flag = [deviceCategory[0], deviceCategory[0]];
      } else {
        flag = deviceCategory;
      }
      try {
        const res = await devicesList({
          page,
          perpage,
          flag: flag,
          addr: address || undefined,
          deviceName: deviceName || undefined,
          deviceModel: deviceModel || undefined,
          deviceNo: deviceNumber || undefined,
          status: status || undefined,
        });
        const { data } = res;
        if (data.count !== undefined) {
          this.totalCount = data.count;
        }
        const records = data.records || [];
        this.listData = [];
        let supportProduct, supports, i = 0;
        for (let row of records) {
          supportProduct = row.supportProduct;
          if (isValueEmpty(supportProduct) || supportProduct === null) {
            this.listData.push({...row, rowspan: 1});
          } else {
            try {
              supports = JSON.parse(supportProduct);
              i = 0;
              this.listData.push({
                ...row,
                supports,
              });
            } catch (e) {
              // do nothing.
            }
          }
        }
      } catch (e) {
        // do nothing.
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.page = 1;
      this.form = Object.assign({}, defaultForm);
      this.searchParams = Object.assign({}, defaultForm);
      this.devicesList();
    },
    queryDevice() {
      this.$refs.refForm.validate(async (valid) => {
        if (valid) {
          this.page = 1;
          this.searchParams = {...this.form};
          this.devicesList();
        }
      });
    },
    deviceStatusVal(row) {
      const {
        status,
      } = row;
      const deviceStatus = defaultDeviceStatus[String(status)];
      return deviceStatus ? deviceStatus.explain : status;
    },
    printDeviceLabel(row) {
      let iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);
      iframe = initDeviceLabel({iframe, ...row, company: '网策科技',});
      setTimeout(() => {
        if (!!window.ActiveXObject || "ActiveXObject" in window) { //是否ie
          remove_ie_header_and_footer();
        }
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
        iframe = null;
      }, 200);
    },
    deleteDevice(id) {
      this.$confirm(this.$t('device.thisActionWillDeleteThisDevice'), this.$t('remindInfo.warning'), {
        confirmButtonText: this.$t('remindInfo.confirm'),
        cancelButtonText: this.$t('remindInfo.cancel'),
        type: 'warning',
      }).then(async () => {
        try {
          await deviceDelete({
            ids: [id],
          });
          this.$message({
            type: 'success',
            message: this.$t('common.deleteSuccess'),
          });
          this.devicesList();
        } catch (e) {
        }
      }).catch(() => {
        // do nothing.
      });
    },
    deviceCategoryVal(flag) {
      return defaultCategoryTypes[flag] ? `${defaultCategoryTypes[flag].explain}` : ''
    },
    formatDate(date) {
      if (!date) {
        return '';
      }
      const updateDate = moment.utc(date);
      return updateDate.local().format('YYYY/MM/DD');
    },
    supportsVal(support) {
      if (!support || support && support.length === 0) {
        return '';
      }
      let supportsVal = [];
      for (let row of support) {
        supportsVal.push(`${row.prod}:${row.testDaily}`);
      }
      return supportsVal.join('\n');
    },
    checkDeviceHistory(id) {
      this.deviceId = id;
      this.deviceHistoryDialogVisible = true;
    },
    async exportDeviceList() {
      this.exportLoading = true;
      try {
        const res = await devicesList({
          flag: [1, 2, 3]
        });
        const { data } = res;
        const records = data.records || [];
        const deviceList = [];
        let supportProduct, supports, i = 0, formatData;
        for (let row of records) {
          supportProduct = row.supportProduct;
          formatData = {
            deviceCategoryVal: this.deviceCategoryVal(row.flag),
            productionDate: this.formatDate(row.productionDate),
            installationDate: this.formatDate(row.installationDate),
            statusVal: this.deviceStatusVal(row),
          };
          if (isValueEmpty(supportProduct) || supportProduct === null) {
            deviceList.push({
              ...row,
              rowspan: 1,
              ...formatData,
            });
          } else {
            try {
              supports = JSON.parse(supportProduct);
              i = 0;
              for (let support of supports) {
                deviceList.push({
                  ...row,
                  prod: support.prod,
                  testDaily: support.testDaily,
                  rowspan: i === 0 ? supports.length : undefined,
                  ...formatData,
                });
                i++;
              }
            } catch (e) {
              // do nothing.
            }
          }
        }
        exportDeviceXlsx({devicesList: deviceList});
      } catch (e) {
        // do nothing.
      } finally {
        this.exportLoading = false;
      }
    },
    subDeviceStatusVal(row) {
      const {
        status,
      } = row;
      const subDeviceStatus = defaultSubDeviceStatus[String(status)];
      return subDeviceStatus ? subDeviceStatus.explain : status;
    },
  }
}
</script>

<style scoped>
.container {
  height: 100%;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.el-form {
  padding: 10px 20px 0;
  border-bottom: 1px solid #E5E5E5;
}
.control-container {
  display: flex;
  display: -webkit-flex;
  flex-direction: row;
  margin: 10px 20px;
}
.target-container {
  flex: 1;
  display: -webkit-flex;
  display: flex;
  margin: 0 20px;
  height: 100%;
  overflow: auto;
}
.link {
  color: #169BD5;
  padding: 0 5px;
}
</style>
<style>
.headerCellName {
  background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
  background: -o-linear-gradient(#F9F9F9, #EEEEEE);
  background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
  background: linear-gradient(#F9F9F9, #EEEEEE);
}
.small_label .el-form-item__label {
  font-size: 12px;
}
</style>
